export const UPGRADE_BUTTON_VARIANTS = {
  starter: "starter",
  pro: "pro",
  default: "secondary",
} as const;

export const PLAN_NAME_MAPPING = {
  starter: "Starter",
  pro: "Pro",
  team: "Team",
} as const;
